export default {
  init() {
    console.log('equipo creativo');

  },

finalize() {
  // JavaScript to be fired on all pages, after page specific JS is fired
},
};



// WEBPACK FOOTER //
// ./scripts/routes/template-equipocreativo.js